@for (row of get(bannerRow, 'category_top_banner.category_top_banner', []); track row) {
  <div>
    @if (row) {
      <section id="hero-banner" [class.pt-0]="isNarrow" [class.pb-4]="isNarrow" [class.p-0]="!isNarrow">
        <div
          id="hero-banner-image"
            [ngStyle]="{
                'background-image': 'url(' + get(row, 'background_image_wide.href', '') + ')'
            }"
          >
          <div id="badge-container" class="d-flex flex-row justify-content-center">
            @if (get(row, 'badge') != 'none') {
              <div class="category-badge d-flex align-items-end">
                <img [src]="getWebpImg(get(row, 'badge', ''))" alt="Category top banner badge image" class="category-badge-img" />
              </div>
            }
          </div>
        </div>
        <div id="hero-banner-content" class="grid container align-items-center">
          <div class="g-col-lg-6 g-col-12 d-flex flex-column">
            <h1 [ngClass]="get(row, 'font_color_light_theme') ? 'font-light-theme' : ''">
              {{ get(row, 'banner_title', '') }}
            </h1>
            <p [ngClass]="get(row, 'font_color_light_theme') ? 'font-light-theme banner-copy' : 'banner-copy'">
              {{ get(row, 'banner_copy', '') }}
            </p>
            <!-- Marketo Form Button -->
            @if (get(row, 'marketo_form_selection.form_selection', '') !== 'no_form') {
              <div class="d-flex flex-row">
                @if (get(row, 'marketo_form_selection.form_selection', '') == 'default_form') {
                  <button-component
                        (click)="
                            solutionID && bootstrapMarketoService.openBootstrapMarketoDialog(solutionID, 'edit', {
                                title: dataTitle,
                                url: dataUrl
                            })
                        "
                    data-cy="marketo-form"
                        [buttonOptions]="{
                            text: get(row, 'button_text_select', ''),
                            type: 'primary',
                            iconPosition: 'right',
                            iconName: 'chevron-right',
                            disabled: !solutionID
                        }"
                  ></button-component>
                }
                @if (get(row, 'marketo_form_selection.form_selection', '') == 'other_form') {
                  <button-component
                        (click)="
                            get(row, 'marketo_form_selection.marketo_forms.id', '') && bootstrapMarketoService.openBootstrapMarketoDialog(get(row, 'marketo_form_selection.marketo_forms.id', ''), 'edit', {
                                title: dataTitle,
                                url: dataUrl
                            })
                        "
                    data-cy="marketo-form"
                        [buttonOptions]="{
                            text: get(row, 'button_text_select', ''),
                            type: 'primary',
                            iconPosition: 'right',
                            iconName: 'chevron-right',
                            disabled: !get(row, 'marketo_form_selection.marketo_forms.id', '')
                        }"
                  ></button-component>
                }
              </div>
            }
            <!-- RouterLink Button -->
            @if (get(row, 'banner_button.href', '')) {
              <div class="d-flex flex-row">
                @if (get(row, 'banner_button.href', '') !== '') {
                  <button
                    class="button-primary"
                    [routerLink]="get(row, 'banner_button.routerLink', '')"
                    >
                    <span>{{ get(row, 'button_text_select', '') }}</span>
                    <mat-icon>chevron_right</mat-icon>
                  </button>
                }
                @if (get(row, 'banner_button.href', '') !== '') {
                  <button-component
                        [buttonOptions]="{
                            text: get(row, 'button_text_select', ''),
                            internalLink: get(row, 'banner_button.routerLink', ''),
                            type: 'primary',
                            iconPosition: 'right',
                            iconName: 'chevron-right'
                        }"
                  ></button-component>
                }
              </div>
            }
          </div>
        </div>
      </section>
    }
  </div>
}
